import { VbzButton } from "@smiles/voebiz-ui-kit";
import React, { FC } from "react";
import { ModalBody } from "reactstrap";

interface SuccessProps {
  onClick: () => void;
}

const ModalSuccessBody: FC<SuccessProps> = ({ onClick }) => (
  <ModalBody>
    <div className="vbz-modal-success-body">
      <div className="vbz-modal-header">
        <h4 className="modal-title-wrapper">Recebemos seu pedido de atualização de dados!</h4>
      </div>
      <div>
        <p className="modal-text-wrapper">
          Suas informações foram encaminhadas para a Central de Relacionamento VoeBiz.
          <br />
          <br />A confirmação será enviada por e-mail em até 15 dias úteis.
        </p>
        <VbzButton id="submit" className="mt-5 smls-register-cpf" color="primary" text="Entendi" onClick={onClick} />
      </div>
    </div>
  </ModalBody>
);

export default ModalSuccessBody;
